import { render, staticRenderFns } from "./LatestReviews.vue?vue&type=template&id=333860ed&scoped=true&"
import script from "./LatestReviews.vue?vue&type=script&lang=js&"
export * from "./LatestReviews.vue?vue&type=script&lang=js&"
import style0 from "./LatestReviews.vue?vue&type=style&index=0&id=333860ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333860ed",
  null
  
)

export default component.exports